import { render } from "./DailyOpsQuestion.vue?vue&type=template&id=b0276b98&scoped=true"
import script from "./DailyOpsQuestion.vue?vue&type=script&lang=js"
export * from "./DailyOpsQuestion.vue?vue&type=script&lang=js"

import "./DailyOpsQuestion.vue?vue&type=style&index=0&id=b0276b98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0276b98"]])

export default __exports__